var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeafC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.764,
    height: 95.762,
    viewBox: "0 0 95.764 95.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(-0.082 -0.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-Copy",
    transform: "translate(-895 -279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto---C",
    transform: "translate(895.082 279.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-9",
    d: "M92.6.009a3.015,3.015,0,0,1,3.15,3.15C95.543,5.6,92.512,60.954,74.8,78.671c-16.981,16.978-36.986,12.995-50.051,3.6-.158-.114-.335-.25-.53-.406L12.439,93.629a7.286,7.286,0,0,1-10.3-10.3L13.9,71.549q-.237-.3-.408-.532C4.1,57.954.114,37.947,17.093,20.966,34.807,3.249,90.166.215,92.6.009Z",
    fill: "#f5c100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M49.141,67.957c7.918,0,14.154-3.567,16.764-9.368a7.274,7.274,0,0,0,.667-2.929,3.771,3.771,0,0,0-4.09-3.887c-1.856,0-2.958.783-3.858,2.755a9.806,9.806,0,0,1-9.6,6.207c-6.7,0-10.905-5.511-10.905-14.444,0-8.817,4.264-14.357,10.876-14.357,4.177,0,7.6,2.146,9.513,6.41.957,2.03,2.2,2.9,4.177,2.9a3.586,3.586,0,0,0,3.858-3.771,7.111,7.111,0,0,0-.87-3.277c-2.871-6.033-8.933-9.513-16.764-9.513-12.037,0-19.723,8.15-19.723,21.637C29.187,59.836,36.728,67.957,49.141,67.957Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafC);
export default __webpack_public_path__ + "static/media/LeafC.d2d25750b37d0fa0733bb503c3925398.svg";
export { ForwardRef as ReactComponent };